import React, { useState } from "react";
import { Search, HelpCircle } from "lucide-react";
import PageHero from "../components/PageHero";
import { faqsFull } from "../mock/pages";
import { site } from "../mock/mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Input } from "../components/ui/input";
import useSeo from "../hooks/useSeo";
import CtaBand from "../components/CtaBand";

export default function FaqPage() {
  useSeo({
    title: "FAQs",
    path: "/faq",
    description:
      "Frequently asked questions about The KPR Academy, Coimbatore - curriculum, admission process, documents, school timings, transport, safety, student-teacher ratio, assessment and parent communication.",
    keywords:
      "KPR Academy FAQ, CBSE school questions, school timings Coimbatore, school transport, student teacher ratio, CBSE assessment",
  });
  const [q, setQ] = useState("");
  const list = faqsFull.filter(
    (f) =>
      f.q.toLowerCase().includes(q.toLowerCase()) ||
      f.a.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <>
      <PageHero
        eyebrow="General Questions"
        title="Frequently asked questions"
        sub="Everything parents ask us before the campus visit — curriculum, admissions, safety, transport and assessment."
        crumbs={[{ label: "Admissions", to: "/admissions" }, { label: "FAQs" }]}
        image="https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjbGFzc3Jvb218ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85"
      />

      <section className="py-24 lg:py-28" style={{ background: "var(--cream)" }}>
        <div className="mx-auto max-w-[900px] px-5 lg:px-6">
          <div className="relative" data-reveal="">
            <Search
              size={17}
              className="absolute left-4 top-1/2 -translate-y-1/2"
              style={{ color: "var(--muted-ink)" }}
            />
            <Input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search the questions…"
              className="h-14 pl-12"
              style={{ background: "#fff", borderColor: "rgba(11,59,54,.14)" }}
            />
          </div>

          <p className="mt-4 text-[0.78rem]" style={{ color: "var(--muted-ink)" }}>
            {list.length} of {faqsFull.length} questions
          </p>

          <Accordion type="single" collapsible defaultValue="item-0" className="mt-8 space-y-4">
            {list.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="overflow-hidden rounded-2xl bg-white px-6"
                style={{ border: "1px solid rgba(11,59,54,.09)" }}
              >
                <AccordionTrigger className="py-6 text-left hover:no-underline">
                  <span className="flex items-start gap-4 pr-3">
                    <HelpCircle size={18} strokeWidth={1.7} style={{ color: "var(--gold)", marginTop: 2 }} />
                    <span className="font-display text-[1.05rem] leading-snug" style={{ color: "var(--teal-900)" }}>
                      {f.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  className="pb-7 pl-[34px] pr-3 text-[0.92rem] leading-relaxed"
                  style={{ color: "var(--muted-ink)" }}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {!list.length && (
            <div className="mt-10 rounded-2xl p-8 text-center" style={{ background: "var(--sand)" }}>
              <p className="font-display text-[1.2rem]" style={{ color: "var(--teal-900)" }}>
                No match for “{q}”
              </p>
              <p className="mt-2 text-[0.88rem]" style={{ color: "var(--muted-ink)" }}>
                Call our admission hotline on {site.hotlines[0]} and we'll answer it directly.
              </p>
            </div>
          )}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
